import React, { Fragment, useState } from 'react';
import { findDOMNode } from 'react-dom';
import { AddToCal2Icon } from '@bizzabo/icons';
import classname from 'classnames';
import { Overlay, Popover} from 'react-bootstrap';
import AddToCalendar from './AddToCalendar';
import FeatureToggleUtils from 'FeatureToggleUtils';
import { getTimeZoneDate } from '../../../web-common/scripts/utils/DateHelper';
import { getVenue } from './SessionLocation';
import { useOpenDialogState } from './useOpenDialogState';
import { getAgendaMagicLink } from '../ApiUtil';
import LoaderView from '../LoaderView';
import {
    sendCustomClick
} from '../../../utils/SnowplowUtils';
import {
    buttonTypes,
    addCalendarSubCategory
} from '../../../constants/SnowplowConst';

function AddToCalButton(props) {
    const [isPopOverOpen, togglePopOverAction, onTipHide] = useOpenDialogState();
    const addToCalRef = React.createRef();
    const { event, color, session, sessionViewType, eventUrls, me } = props;
    const { isJoined = false } = me;
    const isLoggedIn = !!me.id;
    const { websiteType, whitelabelUrl, independentUrl } = event;
    const [magicLink, setMagicLink] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const timeZone = event && event['time-zone-id'];
    const enableMagicLink = FeatureToggleUtils && FeatureToggleUtils.isFeatureEnabled('email-add-to-cal-with-magic-link');

    const handleClick = async(e) => {
        sendCustomClick(buttonTypes.addCalendar, addCalendarSubCategory, addToCalRef);
        togglePopOverAction();
        const sessionId = session.id;
        const eventId = event.id;
        if (enableMagicLink) {
            await generateMagicLink(eventId, sessionId);
        }
    };

    const generateMagicLink = async(eventId, sessionId) => {
        setIsLoading(true);
        const response = await getAgendaMagicLink({ eventId, sessionId });
        setIsLoading(false);
        const { magicLink } = response;
        setMagicLink(magicLink);
    };

    return (
        <React.Fragment>
            <div
                ref={addToCalRef}
                onClick={handleClick}
                className={classname('session-button', {'session-button--toggle': isPopOverOpen})}>
                <AddToCal2Icon fill={`var(--page-main-color, ${color})`} className="calendar"/>
                {sessionViewType === 'sessionPreviewWindow' ?
                    <span>
                    Add to Cal
                    </span> :
                    <Fragment>
                        <span className="full-text">
                                    Add to Calendar
                        </span>
                        <span className="short-text">
                                    Add to Cal
                        </span>
                    </Fragment>
                }
            </div>
            <Overlay target={() => findDOMNode(addToCalRef.current)}
                placement="bottom"
                rootClose={true}
                onHide={onTipHide}
                show={isPopOverOpen}>
                <Popover id="popover-add-to-calendar"
                    className={sessionViewType === 'sessionPreviewWindow' ? 'agenda-button-popover--narrow' : 'agenda-button-popover--wide'}>
                    { isLoading && <LoaderView /> }
                    { !isLoading && <AddToCalendar
                        className={sessionViewType === 'sessionPreviewWindow' ? 'add-to-calendar--narrow' : 'add-to-calendar--wide'}
                        magicLink={magicLink}
                        isLoggedIn={isLoggedIn}
                        sendCustomClick={sendCustomClick}
                        buttonType={buttonTypes.addCalendar}
                        session={session}
                        event={{
                            startTime: getTimeZoneDate(session.startDate, session.startMinute, timeZone),
                            endTime: getTimeZoneDate(session.endDate, session.endMinute, timeZone),
                            location: getVenue(session),
                            title: session.title,
                            description: session.description,
                            timeZone: event && event['time-zone-id'],
                            id: session.id,
                            eventUrls,
                            independentUrl,
                            websiteType,
                            whitelabelUrl,
                            eventId: event.id,
                            accountId: event['account-id'],
                        }}/> }
                </Popover>
            </Overlay>
        </React.Fragment>);
}

export default AddToCalButton;
